import styled from '@emotion/styled';
import notification from 'antd/lib/notification';
import i18n from 'i18next';
import { theme } from '../App.theming';
import SVGRight from '../assets/svgs/SVGRight';
import SVGWrong from '../assets/svgs/SVGWrong';
import { environment } from '../environments/environment';
import { CrudRequestResponseProxy } from '../models/proxies/base/crud-request-response.proxy';
import { NotificationProxy } from '../models/proxies/notification.proxy';
import api from './api';

const notificationStyle = {
  boxShadow: '0px 10px 40px rgba(23, 63, 112, 0.1)',
  borderRadius: '8px',
  background: theme.gradients.primaryLinearGradient,
};

notification.config({
  placement: 'topRight',
  duration: 10,
});

export const RightIcon = styled(SVGRight)`
  height: 5rem;
  width: 3.5rem;
`;

export const WrongIcon = styled(SVGWrong)`
  height: 5rem;
  width: 3.5rem;
`;

export const createSuccessNotification = (description: string, message?: string): void => {
  notification.close(description);

  notification.success({
    message: message || i18n.t('error.success'),
    description: description,
    style: notificationStyle,
    icon: <RightIcon />,
  });
};

export const createErrorNotification = (description: string | string[]): void => {
  const message = Array.isArray(description) ? description[0] : description;

  notification.close(message);

  notification.error({
    key: message,
    message: i18n.t('error.error'),
    description: message,
    style: notificationStyle,
    icon: <WrongIcon />,
  });
};

export async function getNotifications(page: number, limit: number, lastNotificationDate?: string): Promise<CrudRequestResponseProxy<NotificationProxy>> {
  const searchParams = encodeURIComponent(JSON.stringify({
    isActive: true,
    ...lastNotificationDate && {
      createdAt: { $gt: lastNotificationDate },
    },
  }));

  const url = environment.api.notifications.list
    .replace('{searchParams}', searchParams)
    .replace('{sort}', 'createdAt,DESC')
    .replace('{page}', String(page))
    .replace('{limit}', String(limit));

  const { data } = await api.get<CrudRequestResponseProxy<NotificationProxy>>(url);

  return data;
}
